<template>
  <div id="app">
	<router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CookiebotConsentVuex } from 'DcVueCookiebot/mixins/CookiebotConsentVuex.js'
export default {
	name: 'App',
	mixins: [CookiebotConsentVuex],
	computed: {
		...mapState({
			locale: state => state.lang
		}),
		metaTitle() {
			return (typeof this.pageTitle !== 'undefined' && this.pageTitle) ? this.pageTitle : document.title
		},
		metaDescription() {
			return (typeof this.description !== 'undefined' && this.description) ? this.description : this.getMetaTag('description')
		}
	},
	metaInfo() {
		return {
			title: this.metaTitle,
			meta: [
				{ vmid: 'description', name: 'description', content: this.metaDescription }
			]
		}
	},
	methods: {
		getMetaTag(name) {
			var metas = document.getElementsByTagName('meta');
			for (var x=0,y=metas.length; x<y; x++) {
				if (metas[x].name.toLowerCase() == name) {
					return metas[x].content;
				}
			}
			return ''
		}
	},
	mounted() {
		this.addCookiebotConsentListeners()
		if (typeof this.$cookiebot !== 'undefined') this.$cookiebot.consentBanner()
		this.updateCookiebotConsent();
	},
	created() {
		this.$i18n.locale = this.locale
	},
	watch: {
		'locale': function(newVal) {
			this.$i18n.locale = newVal
		}
	}

}
</script>

<style lang="scss">
@import "@/styles/scss/app";
@import "RuterSharedStyles/foundation";
</style>
